import { HIDE_SIDEBAR, SHOW_SIDEBAR, TOOGLE_SIDEBAR,SET_HEADER_TITLE, HOME_CLICK } from "../constants";


export const showSideBar = () => {
	return {
		type: SHOW_SIDEBAR,
	}
};
export const setHeaderTitle = (data) => {
	return {
		type: SET_HEADER_TITLE,
		payload:data
	}
};
export const hideSideBar = () => {
	return {
		type: HIDE_SIDEBAR,
	}
};
export const toogleSideBar = () => {
	return {
		type: TOOGLE_SIDEBAR,
	}
};

export const onHomeClick = (data) => {
  return {
	type: HOME_CLICK,
	payload:data
  };
}